import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-body p-10 p-lg-20" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-content-center mt-15 mb-15"
}
const _hoisted_3 = {
  class: "spinner-border spinner-lg",
  role: "status"
}
const _hoisted_4 = { class: "visually-hidden" }
const _hoisted_5 = { class: "text-center mb-10" }
const _hoisted_6 = { class: "text-dark mb-3" }
const _hoisted_7 = {
  key: 0,
  class: "fv-row mb-0"
}
const _hoisted_8 = {
  for: "newpassword",
  class: "form-label fs-6 fw-bolder mb-3"
}
const _hoisted_9 = { class: "fv-plugins-message-container" }
const _hoisted_10 = { class: "fv-help-block" }
const _hoisted_11 = {
  key: 1,
  class: "fv-row mb-0"
}
const _hoisted_12 = {
  for: "confirmpassword",
  class: "form-label fs-6 fw-bolder mb-3"
}
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = {
  key: 2,
  class: "d-flex flex-wrap justify-content-center pb-lg-0 mt-5"
}
const _hoisted_16 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_password_reset_submit",
  class: "btn btn-lg btn-primary fw-bolder me-4"
}
const _hoisted_17 = { class: "indicator-label" }
const _hoisted_18 = { class: "indicator-progress" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_20 = {
  key: 3,
  class: "notice d-flex bg-light-danger rounded border-danger border border-dashed p-6 mt-5"
}
const _hoisted_21 = { class: "svg-icon svg-icon-2tx svg-icon-danger me-4" }
const _hoisted_22 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_23 = { class: "fw-bold" }
const _hoisted_24 = { class: "text-gray-800 fw-bolder" }
const _hoisted_25 = { class: "fs-6 text-gray-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.t("pleaseWait")), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Form, {
          key: 1,
          class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
          onSubmit: _ctx.onSubmitForgotPassword,
          id: "kt_login_password_reset_form",
          "validation-schema": _ctx.forgotPassword
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.t("editProfile.resetPassword")), 1)
            ]),
            (_ctx.valid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.t("editProfile.newPassword")), 1),
                  _createVNode(_component_Field, {
                    type: "password",
                    class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                    name: "nPassword",
                    id: "newpassword"
                  }),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_ErrorMessage, { name: "nPassword" })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.valid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("editProfile.confirmNewPassword")), 1),
                  _createVNode(_component_Field, {
                    type: "password",
                    class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                    name: "cPassword",
                    id: "confirmpassword"
                  }),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_ErrorMessage, { name: "cPassword" })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.valid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("button", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.t("resetpassword.submit")), 1),
                    _createElementVNode("span", _hoisted_18, [
                      _createTextVNode(_toDisplayString(_ctx.t("pleaseWait")) + " ", 1),
                      _hoisted_19
                    ])
                  ], 512),
                  _createVNode(_component_router_link, {
                    to: "/sign-in",
                    class: "btn btn-lg btn-light-primary fw-bolder"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("resetpassword.cancel")), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (!_ctx.valid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("span", _hoisted_21, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("h4", _hoisted_24, _toDisplayString(_ctx.t("resetpassword.linkExpired")), 1),
                      _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.t("resetpassword.linkExpiredDesc")), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"]))
      : _createCommentVNode("", true)
  ]))
}